"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HeaderCta = /** @class */ (function () {
    function HeaderCta(selector) {
        this.selector = selector;
        this.headerButton = document.querySelector(this.selector);
        if (this.headerButton !== null) {
            this.hero = document.querySelector('.section--hero-teaser');
            this.heroButton = this.hero.querySelector('.hero-teaser__button');
            this.headerButton.setAttribute('href', this.heroButton.getAttribute('href'));
            this.headerButton.innerText = this.heroButton.innerText;
        }
    }
    return HeaderCta;
}());
exports.default = HeaderCta;
